import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const activeStyle = {
  color: colors.text
}

const useBreadcrumbsStyles = createUseStyles({
  breadcrumbsWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: colors.gray300,
    fontWeight: 'normal',

    '& > i.separator': {
      margin: '0 0.25rem'
    }
  },
  breadcrumbsLink: {
    color: colors.gray400,
    border: 0,

    '&:hover': activeStyle,
    '&.active': activeStyle,
    '&.disabled': {
      pointerEvents: 'none'
    }
  }
})

export { useBreadcrumbsStyles }
